(() => {
  const root = document.querySelector('[data-ak-ath-product]');
  if (!root) return;
  function fitSharedHeading() {
    if (!matchMedia('(min-width:1201px)').matches || !window.akFitProductHeading) return;
    root.style.setProperty('--ak-session-one-heading-height', `${window.akProductHeadingHeight(root)}px`);
    window.akFitProductHeading(root);
  }
  document.fonts.ready.then(fitSharedHeading);
  new ResizeObserver(fitSharedHeading).observe(root);
  window.addEventListener('resize', fitSharedHeading, {passive:true});
  const media = root.querySelector('.ak-ath-product__images');
  const pictures = [...media.querySelectorAll('img')];
  function centerPictures() {
    if (pictures.length !== 2 || !matchMedia('(min-width:1201px)').matches) {
      media.style.removeProperty('--ak-ath-image-inset');
      return;
    }
    const widths = pictures.map(image => {
      const box = image.getBoundingClientRect();
      const ratio = image.naturalWidth / image.naturalHeight;
      return Number.isFinite(ratio) ? Math.min(box.width, box.height * ratio) : box.width;
    });
    const gap = Math.max(0, media.clientWidth / 2 - (widths[0] + widths[1]) / 2);
    // Keep the pair centred with a fixed 30px gap, preserving picture size.
    media.style.setProperty('--ak-ath-image-inset', `${(gap - 30) / 2}px`);
  }
  new ResizeObserver(centerPictures).observe(media);
  pictures.forEach(image => image.addEventListener('load', centerPictures));
  window.addEventListener('resize', centerPictures, {passive:true});
  centerPictures();
  const catalog = JSON.parse(root.querySelector('[data-ak-ath-catalog]').textContent);
  const form = root.querySelector('form');
  const add = form.querySelector('[name="add"]');
  const input = form.querySelector('[name="id"]');
  const price = form.querySelector('[data-price]');
  const error = form.querySelector('[role="alert"]');
  const sizeIndex = catalog.options.findIndex(name => /size|størrelse/i.test(name));
  const qualityIndex = catalog.options.findIndex((name, index) => index !== sizeIndex && /thickness|quality|weight|tykkelse|kvalitet|gsm/i.test(name));
  const selected = catalog.options.map((_, index) => {
    const values = [...new Set(catalog.variants.map(variant => variant.options[index]))];
    return values.length === 1 ? values[0] : null;
  });
  const initial = catalog.variants.find(variant => variant.id === catalog.initialVariant);
  if (initial) initial.options.forEach((value, index) => selected[index] = value);
  const groups = [];
  let variant = null;
  let adding = false;
  function setMenuOpen(group, open) {
    clearTimeout(group.hideTimer);
    group.trigger.setAttribute('aria-expanded', String(open));
    if (open) {
      if (group.list.hidden) {
        group.list.hidden = false;
        void group.list.offsetHeight;
      }
      group.list.classList.add('is-open');
    } else {
      group.list.classList.remove('is-open');
      const duration = matchMedia('(min-width:1201px)').matches && !matchMedia('(prefers-reduced-motion:reduce)').matches
        ? group.buttons.length * 40 : 0;
      group.hideTimer = setTimeout(() => { group.list.hidden = true; }, duration);
    }
  }
  function closeAll(except = null) {
    groups.forEach(group => {
      clearTimeout(group.timer);
      if (group === except) return;
      group.pinned = false;
      setMenuOpen(group, false);
    });
  }
  function openMenu(group, pinned = false) {
    closeAll(group);
    group.pinned = pinned || group.pinned;
    setMenuOpen(group, true);
  }
  function sync() {
    variant = selected.every(value => value !== null)
      ? catalog.variants.find(item => item.options.every((value, index) => value === selected[index]))
      : null;
    input.disabled = !variant || !variant.available;
    input.value = variant?.id || '';
    add.disabled = adding || !variant?.available;
    add.textContent = adding ? 'ADDING…' : !catalog.available || (variant && !variant.available) ? 'SOLD OUT' : 'ADD TO CART';
    price.textContent = variant?.price || catalog.emptyPrice;
    const next = groups.find(group => !group.locked && selected[group.index] === null);
    root.dataset.akChoiceNext = next?.name || '';
    root.dataset.akPurchaseState = adding ? 'adding' : variant?.available ? 'ready' : !catalog.available || (variant && !variant.available) ? 'sold-out' : 'missing';
    groups.forEach(group => {
      group.trigger.textContent = group.locked ? 'PREMIUM QUALITY' : selected[group.index] || group.label;
      group.trigger.classList.toggle('is-ak-choice-cta', group === next);
      group.buttons.forEach(button => {
        const value = button.dataset.value;
        const possible = catalog.variants.some(item => item.available && item.options[group.index] === value && selected.every((choice, index) => index === group.index || choice === null || item.options[index] === choice));
        button.disabled = !possible;
        button.setAttribute('aria-pressed', String(selected[group.index] === value));
      });
    });
    if (variant) {
      const url = new URL(location.href);
      url.searchParams.set('variant', variant.id);
      history.replaceState(history.state, '', url);
    }
  }
  root.querySelectorAll('[data-choice]').forEach(element => {
    const index = element.dataset.choice === 'size' ? sizeIndex : qualityIndex;
    const group = {index, name:element.dataset.choice, trigger:element.querySelector('button'), list:element.querySelector('.ak-ath-product__options'), buttons:[], pinned:false, timer:null};
    group.label = group.trigger.textContent.trim();
    groups.push(group);
    const values = index < 0 ? [] : [...new Set(catalog.variants.map(item => item.options[index]))];
    group.locked = values.length <= 1;
    if (group.locked) {
      group.trigger.disabled = true;
      group.trigger.textContent = 'PREMIUM QUALITY';
      return;
    }
    values.forEach(value => {
      const button = document.createElement('button');
      button.type = 'button';
      button.textContent = value;
      button.dataset.value = value;
      button.addEventListener('click', () => {
        const size = groups.find(item => item.name === 'size');
        if (group.name !== 'size' && size && !size.locked && selected[size.index] === null) {
          openMenu(size, true); size.trigger.focus(); return;
        }
        selected[index] = value;
        error.hidden = true;
        sync(); closeAll(); group.trigger.focus();
      });
      group.list.append(button);
      group.buttons.push(button);
    });
    group.list.style.setProperty('--ak-option-row-count', group.buttons.length);
    group.buttons.forEach((button, index) => button.style.setProperty('--ak-option-row-index', group.buttons.length - 1 - index));
    group.trigger.addEventListener('pointerenter', () => {
      if (matchMedia('(hover:hover) and (pointer:fine)').matches) openMenu(group);
    });
    element.addEventListener('pointerenter', () => clearTimeout(group.timer));
    element.addEventListener('pointerleave', () => {
      if (!matchMedia('(hover:hover) and (pointer:fine)').matches || group.pinned) return;
      group.timer = setTimeout(() => {
        setMenuOpen(group, false);
      },120);
    });
    group.trigger.addEventListener('click', () => {
      const opening = group.trigger.getAttribute('aria-expanded') !== 'true' || !group.pinned;
      if (opening) openMenu(group, true);
      else closeAll();
    });
    group.trigger.addEventListener('keydown', event => {
      if (event.key !== 'ArrowDown' && event.key !== 'ArrowUp') return;
      event.preventDefault(); openMenu(group, true);
      const buttons = group.buttons.filter(button => !button.disabled);
      (event.key === 'ArrowUp' ? buttons.at(-1) : buttons[0])?.focus();
    });
    group.list.addEventListener('keydown', event => {
      if (event.key === 'Escape') { closeAll(); group.trigger.focus(); }
      if (event.key !== 'ArrowDown' && event.key !== 'ArrowUp') return;
      event.preventDefault();
      const buttons = group.buttons.filter(button => !button.disabled);
      const current = buttons.indexOf(document.activeElement);
      buttons[(current + (event.key === 'ArrowDown' ? 1 : -1) + buttons.length) % buttons.length]?.focus();
    });
  });
  document.addEventListener('click', event => { if (!event.target.closest('.ak-ath-product__choice')) closeAll(); });
  document.addEventListener('keydown', event => { if (event.key === 'Escape') closeAll(); });
  document.addEventListener('focusin', event => { if (!event.target.closest('.ak-ath-product__choice')) closeAll(); });
  form.addEventListener('submit', async event => {
    event.preventDefault();
    if (adding || !variant?.available) return;
    adding = true; error.hidden = true; add.setAttribute('aria-busy', 'true'); closeAll(); sync();
    try {
      const response = await fetch(`${window.Shopify?.routes?.root || '/'}cart/add.js`, {
        method:'POST', headers:{'Content-Type':'application/json',Accept:'application/json'},
        body:JSON.stringify({items:[{id:variant.id,quantity:1}],sections:'cart-items,cart-footer,cart-item-count,cart-live-region',sections_url:location.pathname})
      });
      const result = await response.json();
      if (!response.ok || result.status) throw new Error(result.description || result.message || 'Could not add this item. Please try again.');
      document.body.dispatchEvent(new CustomEvent('baseline:cart:afteradditem',{bubbles:true,detail:{response:result,sourceId:form.id}}));
      window.dispatchEvent(new CustomEvent('ak-open-cart'));
    } catch (failure) { error.textContent = failure.message; error.hidden = false; }
    finally { adding = false; add.removeAttribute('aria-busy'); sync(); }
  });
  const galleryButton=root.querySelector('.ak-ath-product__explore');
  const gallery=document.querySelector('[data-ak-room-preview]');
  const purchase=root.querySelector('.ak-ath-product__purchase');
  const desktop=matchMedia('(min-width:1201px)');
  const reduced=matchMedia('(prefers-reduced-motion:reduce)');
  const controller=new AbortController();const signal=controller.signal;
  let inGallery=false;
    function syncScroll() {
        if (!desktop.matches || !gallery) return;
        const top = gallery.getBoundingClientRect().top;
        const next = top < purchase.getBoundingClientRect().top;
        if (next !== inGallery) {
            inGallery = next;
            galleryButton.firstElementChild.textContent = next ? 'Top' : 'Explore';
            galleryButton.lastElementChild.classList.toggle('is-up', next);
            galleryButton.setAttribute('aria-label', next ? 'Back to product' : 'View product gallery');
        }
    }

    galleryButton.addEventListener('click', function () {
        const detailsLabel = document.querySelector('[data-ak-details-label]');
        if (!desktop.matches) {
            const main=document.getElementById('MainContent');
            if(main && detailsLabel) main.scrollTo({top:main.scrollTop+detailsLabel.getBoundingClientRect().top-main.getBoundingClientRect().top,behavior:reduced.matches?'instant':'smooth'});
            return;
        }

        const destination = inGallery ? root : (detailsLabel || gallery);
        if (!destination) return;
        const destinationRect = destination.getBoundingClientRect();
        const targetY = inGallery
            ? 0
            : Math.max(
                0,
                window.scrollY
                    + destinationRect.top
                    + (destinationRect.height / 2)
                    - (window.innerHeight / 2)
            );

        if (reduced.matches) {
            window.scrollTo(0, targetY);
            return;
        }

        const startY = window.scrollY;
        const distance = targetY - startY;
        const duration = 1200;
        const startTime = performance.now();

        function animateScroll(currentTime) {
            const elapsed = currentTime - startTime;
            const progress = Math.min(elapsed / duration, 1);
            const eased = 1 - Math.pow(1 - progress, 4);

            window.scrollTo(0, startY + distance * eased);

            if (progress < 1) {
                requestAnimationFrame(animateScroll);
            }
        }

        requestAnimationFrame(animateScroll);
    }, { signal });
    window.addEventListener(
        'scroll',
        syncScroll,
        {
            passive: true,
            signal
        }
    );

  function scheduleExploreState(){requestAnimationFrame(syncScroll);}
  ['load','resize','ak:boot-revealed','ak:global-frame-ready'].forEach(name=>window.addEventListener(name,scheduleExploreState));
  document.fonts?.ready.then(scheduleExploreState);
  new ResizeObserver(scheduleExploreState).observe(document.querySelector('[data-ak-session-story]'));
  syncScroll();
  sync();
})();
